import { signal, WritableSignal } from "@angular/core";
import { AppAvailability } from "@app/core";


//TODO:DIW:Rename AppManagementModel
export class AppManagementModel {
  public apps: WritableSignal<AppAvailability> = signal<AppAvailability>(undefined);
}


export class NotificationState {
  public notifications: WritableSignal<any[]> = signal<any[]>([]);
}
